<template>
  <div class="container-fluid p-0">
    <div class="row ml-0 mr-0 w-100">
      <div class="col-5 pl-0 pr-0">
        <div
          class="d-flex justify-content-center"
          style="padding: 75px 0px 75px 0px"
        >
          <div class="newLoginMainLayout">
            <div class="newLoginFiifiTitle">fiifi</div>
            <div style="margin-top: 50px">
              <div class="newLoginTitle">Login</div>
            </div>
            <div style="margin-top: 20px">
              <div class="newLoginSubtitle">
                Welcome Back. Don't miss your next opportunity.Login to stay
                updated on your portfolio.
              </div>
            </div>
            <form>
              <div style="margin-top: 20px">
                <div class="newLoginFormTitles">Email or Username</div>
                <div style="margin-top: 10px">
                  <input type="text" class="form-control" />
                </div>
              </div>
              <div style="margin-top: 20px">
                <div class="d-flex">
                  <div class="flex-grow-1">
                    <div class="newLoginFormTitles">Password</div>
                  </div>
                  <div class="d-flex" @click="showPassword = !showPassword">
                    <div
                      class="d-flex"
                      style="margin-right: 5px; cursor: pointer"
                    >
                      <img :src="getSrc" />
                    </div>
                    <div
                      class="d-flex my-auto newLoginShowHideIcon"
                      style="cursor: pointer"
                    >
                      {{ getText }}
                    </div>
                  </div>
                </div>
                <div style="margin-top: 10px">
                  <input :type="getType" class="form-control" />
                </div>
              </div>
              <div style="margin-top: 40px">
                <button
                  :disabled="isSubmit"
                  type="submit"
                  class="todo-form-submit-button btn btn-primary mb-0 w-100"
                >
                  Login
                  <b-spinner
                    v-if="showSpinner"
                    style="float: right"
                    small
                    label="Loading..."
                  ></b-spinner>
                </button>
              </div>
            </form>
            <div style="margin-top: 30px">
              <div class="d-flex justify-content-center">
                <div style="cursor: pointer">
                  <a class="newLoginForgotPassword" href="#/forgot-password"
                    >Forgot Password?</a
                  >
                </div>
              </div>
              <div style="margin-top: 10px">
                <div class="d-flex justify-content-center">
                  <div class="newLoginForgotPassword" style="color: #00000080">
                    Don't have a account?
                    <a class="newLoginForgotPassword" href="#/signup">
                      Sign up</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div style="margin-top: 40px">
              <div class="d-flex justify-content-center">
                <div class="newLoginForgotPassword" style="color: #00000080">
                  Or you can Login with
                </div>
              </div>
              <div
                class="d-flex justify-content-center"
                style="margin-top: 15px"
              >
                <div class="ltseBtnDiv" style="margin-right: 20px">
                  <a :href="ltseUrl">
                    <img src="static/img/ltse.png" class="suggestImage" />
                  </a>
                </div>
                <div style="margin-right: 20px">
                  <a :href="linkedinUrl">
                    <img src="static/img/link-icon.png" class />
                  </a>
                </div>
                <div style="margin-right: 20px">
                  <a :href="twitterUrl">
                    <img src="static/img/twitter-icon.png" class />
                  </a>
                </div>
                <div style="margin-top: 3px">
                  <a :href="googleUrl">
                    <img src="static/img/google-icon.png" class />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-7 pl-0 pr-0">
        <div
          class="newLoginBackgroundImage"
          style="min-height: 100vh; height: auto"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "testPage",
  data() {
    return {
      showSpinner: false,
      isSubmit: false,
      showPassword: false,
      googleUrl: "",
      twitterUrl: "",
      linkedinUrl: "",
      ltseUrl: "",
    };
  },
  computed: {
    getSrc() {
      return !this.showPassword
        ? "static/img/eye.svg"
        : "static/img/eye-hide.svg";
    },
    getText() {
      return !this.showPassword ? "Show" : "Hide";
    },
    getType() {
      return !this.showPassword ? "password" : "text";
    },
  },
};
</script>
<style>
.newLoginBackgroundImage {
  background-image: url("../../../../public/static/img/newLoginBg.svg");
  background-size: cover;
}

.newLoginMainLayout {
  justify-content: "flex-start";
  width: 350px;
}

.newLoginFiifiTitle {
  color: #593bfd;
  font-size: 40px;
  font-family: Comfortaa, cursive;
  opacity: 1;
  font-weight: bold;
}
</style>